import { FC } from 'react'
import { useFormikContext, getIn } from 'formik'

import { FormFieldCheckboxProps } from '../FormFieldCheckbox'
import FormikField from '../../FormikField'
import { FormLabelProps } from '../../FormLabel'

import * as SC from './styled'

export type FormFieldCheckboxGroupProps = {
  className?: string
  label?: string
  text?: string
  labelProps?: FormLabelProps
  name: string
  options: Array<Omit<FormFieldCheckboxProps, 'name'>>
  required?: boolean
  disabled?: boolean
  help?: string
  hasError?: boolean
}

const FormFieldCheckboxGroup: FC<FormFieldCheckboxGroupProps> = ({
  className,
  name,
  label,
  text,
  labelProps,
  options,
  required,
  disabled,
  help,
}) => {
  const { errors } = useFormikContext()
  const error = getIn(errors, name)

  return (
    <SC.Wrapper className={className} $isDisabled={disabled}>
      {label && (
        <SC.Label required={required} {...labelProps}>
          {label}
        </SC.Label>
      )}
      {text && <SC.Text>{text}</SC.Text>}
      <SC.Options>
        {options.map((option) => (
          <FormikField
            {...option}
            key={option.value}
            name={name}
            type="checkbox"
            Component={SC.Checkbox}
            isGroupChild
            disabled={disabled || option.disabled}
            hideError={true}
          />
        ))}
      </SC.Options>
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Wrapper>
  )
}

export default FormFieldCheckboxGroup
